import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";

import * as styles from "./styles.module.scss";
import AddNewSite from "./AddNewSite";
import SelectExistingSite from "./SelectExistingSite";
import { noop } from "shared-frontend/functions/noop";
import { defineMessages, FormattedMessage } from "react-intl";
import useRequest from "../../reactHooks/useRequest";
import { getUserId } from "shared-frontend/functions/auth";

const messages = defineMessages( {
	or: {
		id: "install.or",
		defaultMessage: "or",
	},
} );

/**
 * Initializes the site selector for new or existing sites.
 *
 * @param {Object} props The component properties.
 *
 * @returns {React.JSX.Element} The rendered component.
 */
const SelectOrAddSite = ( props ) => {
	const [ selectedSiteUrl, setSelectedSiteUrl ]         = useState( null );
	const [ validatedNewSiteUrl, setValidatedNewSiteUrl ] = useState( null );
	const [ rawNewSiteInput, setRawNewSiteInput ]         = useState( "" );

	// Fetch the user's sites. We don't want to show the existing sites section if there are none.
	const userId          = getUserId();
	const getSitesRequest = useRequest( `Customers/${ userId }/sites` );

	useEffect( () => {
		const siteValue = selectedSiteUrl || validatedNewSiteUrl;
		props.onSiteUrlChange( siteValue );
	}, [ selectedSiteUrl, validatedNewSiteUrl ] );

	/**
	 * Renders the selectOrAddSite component.
	 *
	 * @returns {ReactElement} The selectOrAddSite component.
	 */
	return (
		<>
			{ getSitesRequest.data.length !== 0 &&
				<>
					<SelectExistingSite
						selectedSiteUrl={ selectedSiteUrl }
						selectionChanged={ setSelectedSiteUrl }
						existingSites={ getSitesRequest.data }
						disabled={ rawNewSiteInput !== "" }
					/>
					<span className={ styles.orSeparator }><FormattedMessage { ...messages.or } /></span>
				</>
			}

			<AddNewSite
				rawNewSiteInput={ rawNewSiteInput }
				onUrlChange={ setRawNewSiteInput }
				onValidUrl={ setValidatedNewSiteUrl }
				disabled={ selectedSiteUrl !== null }
			/>
		</>
	);
};

SelectOrAddSite.propTypes = {
	onSiteUrlChange: PropTypes.func,
};

SelectOrAddSite.defaultProps = {
	onSiteUrlChange: noop,
};

export default SelectOrAddSite;
